import { claimsSchedule } from './request';
import perfectInfo from './perfectInfo.vue';
import info from './info.vue';
import mailWrite from './modelForm/mailWrite.vue';
import seeMail from './modelForm/seeMail.vue';
import seeMailBaoSi from './modelForm/seeMailBaoSi.vue';
import closeCase from './modelForm/closeCase.vue';
import mail from './modelForm/mail.vue';
import { mapState } from 'vuex';
export default {
  components: {
    perfectInfo,
    info,
    mailWrite,
    seeMail,
    closeCase,
    seeMailBaoSi,
    mail
  },
  computed: {
    ...mapState({
      customerId: state => state.user.accountInfo.customerId,
      tag: state => state.user.accountInfo.tag
    })
  },
  data() {
    return {
      step: 0,
      scheduleList: [],
      scheduleInfo: {},
      //当前节点信息
      showCont: false,
      currentThis: this
    };
  },
  filters: {
    typeFilters(val, tag, currentThis) {
      let cont = '';
      switch (val) {
        case 1:
          cont = currentThis.$t('提交报案信息');
          break;
        case 2:
          cont = currentThis.$t('审核中');
          break;
        case 3:
          cont = tag == 0 ? currentThis.$t('案件审核通过,请完善资料') : currentThis.$t('案件审核通过,等待完善资料');
          break;
        case 4:
          cont = currentThis.$t('完善资料已提交');
          break;
        case 5:
          cont = currentThis.$t('审核通过');
          break;
        case 6:
          cont = currentThis.$t('拒绝赔付');
          break;
        case 7:
          cont = currentThis.$t('配置邮寄信息');
          break;
        case 8:
          cont = currentThis.$t('单证邮寄中');
          break;
        case 9:
          cont = currentThis.$t('待结案');
          break;
        case 10:
          cont = currentThis.$t('已结案');
      }
      return cont;
    },
    nameFilters(val, tag, currentThis) {
      let cont = '';
      if (val.type == 3 && tag == 0) {
        cont = val.userName ? currentThis.$t('查看信息') : currentThis.$t('完善资料');
      } else if (val.type == 1 || val.type == 2) {
        cont = currentThis.$t('报案信息');
      } else if (val.type == 8) {
        cont = tag == 0 ? currentThis.$t('填写邮寄资料') : currentThis.$t('客户邮寄信息');
      } else if (val.type == 10) {
        cont = currentThis.$t('已结案');
      } else if (val.type == 4) {
        cont = currentThis.$t('资料已提交');
      } else if (val.type == 9 && tag == 1) {
        cont = currentThis.$t('结案');
      } else if (val.type == 7 && tag == 1) {
        cont = !val.userName ? currentThis.$t('配置邮寄信息') : currentThis.$t('邮寄信息');
      }
      return cont;
    }
  },
  created() {
    this.getScheduleFun();
  },
  methods: {
    async getScheduleFun() {
      this.scheduleList = await claimsSchedule({
        claimsId: this.$route.params.id
      });
      if (this.scheduleList.length != 0) {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
        if (this.scheduleInfo.type == 9 && this.tag != 1) {
          let obj = this.scheduleList[this.scheduleList.length - 2];
          if (obj.type == 6) {
            this.scheduleInfo = obj;
            this.goInfoFun(obj);
          } else {
            this.goInfoFun(this.scheduleInfo);
          }
        } else {
          this.goInfoFun(this.scheduleInfo);
        }
        this.showCont = true;
        if (this.scheduleInfo.type == 1) {
          this.step = 1;
        } else if (this.scheduleInfo.type > 1 && this.scheduleInfo.type <= 6) {
          this.step = 2;
        } else if (this.scheduleInfo.type > 6 && this.scheduleInfo.type <= 8) {
          this.step = 3;
        } else if (this.scheduleInfo.type > 8 && this.scheduleInfo.type < 10) {
          this.step = 4;
        } else if (this.scheduleInfo.type == 10) {
          this.step = 5;
        }
      }
    },
    goInfoFun(val) {
      if (val.type == 9 && val.userName && this.tag != 1) {
        return false;
      } else if (val.type == 3 && val.userName && this.tag != 0) {
        return false;
      }
      this.showCont = false;
      this.scheduleInfo = val;
      setTimeout(() => {
        this.showCont = true;
        if (this.type == 8) {
          this.$refs.mailWriteFrom.init(val.id);
        }
      }, 100);
    }
  }
};